import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('service', ['topmenu']),
  },
  created() {
    if (this.$route.query.topmenu === 'false') {
      this.setTopMenu(false);
    }

    if (!!this.$route.query.topmenucolor && this.$route.query.topmenucolor.length === 6) {
      document.documentElement.style.setProperty('--header-background-color', `#${this.$route.query.topmenucolor}`);
    }

    if (this.$route.query.topmenuhideboxshadow === 'true') {
      document.documentElement.style.setProperty('--header-box-shadow', 'none');
    }
  },
  methods: {
    ...mapActions('service', ['setTopMenu']),
  },
};
